document.addEventListener("DOMContentLoaded", function () {
  const quickShopSpans = document.querySelectorAll(".quick_shop span");

  quickShopSpans.forEach(function (span) {
    span.addEventListener("click", function (e) {
      
        setTimeout(() => {
            document.querySelectorAll(
            ".purchase-details__buttons .action_button.add_to_cart span"
            ).forEach(function(el){
                el.innerHTML = "Add to cart"
            })        
        },200);
        setTimeout(() => {
            document.querySelectorAll(
            ".purchase-details__buttons .action_button.add_to_cart span"
            ).forEach(function(el){
                el.innerHTML = "Add to cart"
            })        
        },500);

        setTimeout(() => {
            document.querySelectorAll(
            ".purchase-details__buttons .action_button.add_to_cart span"
            ).forEach(function(el){
                el.innerHTML = "Add to cart"
            })        
        },700);
    });
  });
});